"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forgotPasswordApiToken = void 0;
var Api_1 = require("@/api/remote/Api");
exports.forgotPasswordApiToken = function (form, recaptchaResponse, langCode, token) {
    Api_1.simulateFormPost("/" + langCode + "/account/forgotpassword", token, [
        ['Email', form.email],
        ['IsResendVerification', false],
        ['g-recaptcha-response', recaptchaResponse],
    ]);
};
